export default "__VITE_ASSET__3eVx6en$__"